import { render, staticRenderFns } from "./RentalDuration.vue?vue&type=template&id=06ba6a26&scoped=true"
import script from "./RentalDuration.vue?vue&type=script&lang=ts"
export * from "./RentalDuration.vue?vue&type=script&lang=ts"
import style0 from "./RentalDuration.vue?vue&type=style&index=0&id=06ba6a26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ba6a26",
  null
  
)

export default component.exports